import React from 'react';
import PropTypes from 'prop-types';

// import hooks
import { useLetterActions } from '../hooks';

// import styled components
import { PreLoanLetterButton, PreLoanLetterButtonWrapper } from '../styled';

// import svg
import { ReactComponent as ViewLetterIcon } from '../../../../assets/buttons/view-letter.svg';
import { ReactComponent as DownloadLetterIcon } from '../../../../assets/buttons/download-letter.svg';
import { ReactComponent as CreateLetterIcon } from '../../../../assets/buttons/create-letter.svg';

function PreLoanLetterLevelTwoButtons({ fileName, letterData, loadingLetter, mobileOnly, toggleModify }) {
  const [previewLetterPdf, downloadLetterPdf] = useLetterActions(letterData, fileName);

  return (
    <PreLoanLetterButtonWrapper className={mobileOnly ? 'mobile-only' : ''}>
      <PreLoanLetterButton disabled={loadingLetter} onClick={() => previewLetterPdf()}>
        <ViewLetterIcon /> View Letter
      </PreLoanLetterButton>
      <PreLoanLetterButton disabled={loadingLetter} onClick={() => downloadLetterPdf(letterData, fileName)}>
        <DownloadLetterIcon /> Download Letter
      </PreLoanLetterButton>
      <PreLoanLetterButton disabled={loadingLetter} onClick={() => toggleModify(mobileOnly)}>
        <CreateLetterIcon /> Modify Letter
      </PreLoanLetterButton>
    </PreLoanLetterButtonWrapper>
  );
}

export default PreLoanLetterLevelTwoButtons;

PreLoanLetterLevelTwoButtons.propTypes = {
  fileName: PropTypes.string.isRequired,
  /**
   * letterData is initially null, even with default prop set, so not set to required
   */
  letterData: PropTypes.object,
  loadingLetter: PropTypes.bool.isRequired,
  mobileOnly: PropTypes.bool.isRequired,
  toggleModify: PropTypes.func.isRequired,
};
